import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "swiper/css/effect-fade";
import "./Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";
import Home_banner from "./home_banner/Home_banner";
import ScrollAnimation from "react-animate-on-scroll";

function Banner({ banner }) {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      disable: false, // VERY IMPORTANT → enable on mobile
      startEvent: "DOMContentLoaded",
      mirror: true,
      offset: 0,
    });
    AOS.refresh();
  }, []);

  // AOS.init({ disable: 'mobile' });

  return (
    <section
      className="home-banner-holder"
      // data-aos="zoom-in"
      // data-aos-duration="2000"
    >
      <Swiper
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, EffectFade]}
        effect="fade"
        className="home_banner_swiper"
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
      >
        {banner?.map((val) => (
          <SwiperSlide>
            <div className="banner-zoom">
              <Home_banner val={val} />
            </div>
          </SwiperSlide>
        ))}

        {/* <SwiperSlide>
          <Home_banner />
        </SwiperSlide>
        <SwiperSlide>
          <Home_banner />
        </SwiperSlide> */}
      </Swiper>
    </section>
  );
}

export default Banner;
